import React from "react";

function Hero() {
  return (
    <section id="top" className="hero">
      <div className="hero__inner">
        <span className="hero__eyebrow" data-reveal>
          <span className="dot" />
          SOUNDWISDOM · ESTABLISHED 2024
        </span>

        <h1 className="hero__title">
          <span className="line" data-reveal>
            <span>声音 · 影像 · </span>
            <span className="ink-italic">叙事</span>
          </span>
          <span className="line" data-reveal data-reveal-delay="1">
            <span className="stroke">的下一种</span>
            <span> 形态</span>
          </span>
        </h1>

        <p className="hero__sub" data-reveal data-reveal-delay="2">
          慧声计算机科技 — 用生成式 AI 重塑互动叙事与影游内容创作。
          我们打造创作者的工具，也搭建观众与故事之间的全新连接。
        </p>

        <div className="hero__actions" data-reveal data-reveal-delay="3">
          <a className="btn btn--primary" href="#products">
            探索产品矩阵 <span className="arrow">→</span>
          </a>
          <a
            className="btn btn--ghost"
            href="mailto:zhangyuntian@soundwisdomai.com"
          >
            漫剧合作 <span className="arrow">→</span>
          </a>
        </div>

        <div className="hero__meta" data-reveal data-reveal-delay="4">
          <span>SHENZHEN · 粤 ICP 备 2024338424 号</span>
          <span>
            <strong>3</strong>&nbsp;PRODUCTS&nbsp;·&nbsp;<strong>1</strong>
            &nbsp;ECOSYSTEM
          </span>
        </div>

        <div className="hero__scroll" aria-hidden="true">
          <span>SCROLL</span>
          <span className="bar" />
        </div>
      </div>
    </section>
  );
}

export default Hero;
